<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-address-book"></i> Contato Externo</h3>
      </div>
    </div>
    <ContactExternalAdd v-if="showAdd" ref="ContactExternalAdd" v-on:Back="onBack" />
    <ContactExternalList v-else ref="ContactExternalList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import ContactExternalAdd from './components/add/ceadd.vue'
import ContactExternalList from './components/list/celist.vue'

export default {
  name: 'ContactExternal',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    ContactExternalAdd,
    ContactExternalList
  },
  mounted () {
    // Tools.MinimizedSidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.ContactExternalAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
      // this.$refs.ContactExternalList.onLoad()
    }
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/contacts/external/contactexternal.vue